module.exports = __webpack_public_path__ + "media/placeholder-images/placeholder_1-86bd292c.jpg";